import React, { useMemo } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AIChatWidget as AIChatWidgetCore } from './AIChatWidget';
import { WidgetErrorBoundary } from './WidgetErrorBoundary';
// Export the core component for cases where QueryClient is already provided (e.g., Storybook)
export { AIChatWidget as AIChatWidgetCore } from './AIChatWidget';
// Default export: wrapped component with QueryClientProvider + top-level error
// boundary. The boundary is the catch-all so any unhandled render error shows a
// recovery card with a Restart action instead of the widget silently vanishing
// for a live customer.
export default function AIChatWidget(props) {
    const queryClient = useMemo(() => new QueryClient(), []);
    return (React.createElement(QueryClientProvider, { client: queryClient },
        React.createElement(WidgetErrorBoundary, null,
            React.createElement(AIChatWidgetCore, Object.assign({}, props)))));
}
